import { useNavigate } from 'react-router-dom'

import { Button } from '@paysense-india-services/elevate-web'

import CardComponent from '@/components/CardComponent'
import Section from '@/components/Section'

const ForeclosureCard = ({ data }) => {
  const navigate = useNavigate()
  const component = data?.components?.items?.[0]

  if (!component) {
    return null
  }

  const handlePayClick = () => {
    if (component?.actions?.default?.url) {
      navigate(component.actions.default.url)
    }
  }

  return (
    <Section title={data?.title}>
      <CardComponent>
        <div className='ew-d-flex ew-justify-content-between ew-align-items-center'>
          <span className='ew-fw-semi-bold'>{component.title}</span>
          <span className='ew-fw-semi-bold'>{component.subtitle}</span>
        </div>
        {component.description ? (
          <div className='ew-typography-small ew-color-secondary ew-fw-regular ew-mt-4'>
            {component.description}
          </div>
        ) : null}
        {component?.actions?.default?.text ? (
          <Button
            className='ew-mt-24 ew-w-100'
            onClick={handlePayClick}
            size='medium'
            variant='brand'>
            {component.actions.default.text}
          </Button>
        ) : null}
      </CardComponent>
    </Section>
  )
}

export default ForeclosureCard
